/**
 * 其他
 */
import { Modal } from 'antd';
import ModalClose from '@ui/button/modal-close';
import { message } from 'antd';
import globalStore from '@src/store/global';
import infoImg from '@/assets/img/antd_msg_info.png';
import successImg from '@/assets/img/antd_msg_success.png';
import errorImg from '@/assets/img/antd_msg_error.png';
import warningImg from '@/assets/img/antd_msg_warning.png';

const getIcon = method => {
  switch (method) {
    case 'info':
      return infoImg;
    case 'success':
      return successImg;
    case 'error':
      return errorImg;
    case 'warning':
      return warningImg;
    default:
      return successImg;
  }
};

const Other = {
  toast(msg, method = 'success', onClose = () => {}) {
    // 追踪错误和警告堆栈
    if (['error', 'warning'].includes(method)) {
      const error = new Error(msg)
      console.error(error)
    }
      
    message[method]({
      content: msg,
      onClose,
      icon: (
        <img src={getIcon(method)} className="size-16px text-white mr-8px" />
      ),
      className: 'assistant-toast-modal',
    });
  },

  confirm({
    title = '温馨提示',
    content,
    className = '',
    wrapClassName = '',
    closable = true,
    keyboard = true,
    cancelButtonProps,
    centered = true,
    onOk = () => {},
    onCancel = () => {},
    okText,
    okButtonProps,
  }) {
    const _Modal = globalStore.AntdModal || Modal;

    return _Modal.confirm({
      title,
      okText: okText || '确认',
      cancelText: '取消',
      className: `so-modal-confirm ${className}`,
      wrapClassName,
      closable,
      keyboard,
      closeIcon: <ModalClose />,
      icon: null,
      centered,
      okButtonProps: okButtonProps || { shape: 'round', danger: true },
      cancelButtonProps,
      content,
      onOk,
      onCancel,
    });
  },
};

export const toast = Other.toast;

window.Other = Other;

export default Other;
